import React, { createContext, useState } from "react";

export let fmLabelsContext = createContext(0);

const LabelsContext = ({ children }) => {
  let [labelMsg, setLabelMsg] = useState("");

  let [filtrationDetails, setFiltrationDetails] = useState({
    search_query: "",
    only_trashed: 0,
  });

  let [isFiltrationLoading, setIsFiltrationLoading] = useState(false);

  let fmLabelsLifting = {
    labelMsg,
    setLabelMsg,
    filtrationDetails,
    setFiltrationDetails,
    isFiltrationLoading,
    setIsFiltrationLoading,
  };

  return (
    <>
      <fmLabelsContext.Provider value={{ ...fmLabelsLifting }}>{children}</fmLabelsContext.Provider>
    </>
  );
};

export default LabelsContext;
